import type { FieldApi } from '@tanstack/react-form'
import { type DeepKeys, type DeepValue, useField } from '@tanstack/react-form'
import { type ReactNode, useState } from 'react'
import { useFormContext } from '../createAppFormHook'

export interface ArrayPushChildrenParams<
  TParentData,
  TName extends DeepKeys<TParentData>,
  TData extends DeepValue<TParentData, TName>,
  TArgs extends unknown[],
> {
  onClick: (...args: TArgs) => void
  loading: boolean
  field: FieldApi<
    TParentData,
    TName,
    TData,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never,
    never
  >
}

export interface ArrayPushProps<
  TParentData,
  TName extends DeepKeys<TParentData>,
  TData extends DeepValue<TParentData, TName>,
  TArgs extends unknown[],
> {
  name: string
  onAdd: (...args: TArgs) => Promise<TData> | TData
  afterAdded?: (value: TData) => void
  children: (params: ArrayPushChildrenParams<TParentData, TName, TData, TArgs>) => ReactNode
}

export function ArrayPush<
  TParentData,
  TName extends DeepKeys<TParentData>,
  TData extends DeepValue<TParentData, TName>,
  TArgs extends unknown[],
>(props: ArrayPushProps<TParentData, TName, TData, TArgs>) {
  const { name, onAdd, afterAdded, children } = props
  const form = useFormContext<TParentData>()
  const field = useField({ name, form, mode: 'array' })
  const [loading, setLoading] = useState(false)

  const handleClick = async (...arg: TArgs) => {
    setLoading(true)
    try {
      const newValue = await onAdd(...arg)
      field.pushValue(newValue as never)
      afterAdded?.(newValue)
    } finally {
      setLoading(false)
    }
  }

  return <>{children({ onClick: handleClick, loading, field } as never)}</>
}
